import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SlideInAnimation = keyframes(["0%{opacity:0;transform:scale(0.9);}100%{opacity:1;transform:scale(1);}"]);
const StyledUIAlert = styled(UIAlert).withConfig({
  displayName: "NewMessagesAlert__StyledUIAlert",
  componentId: "sc-1j40y88-0"
})(["&&{position:absolute;top:60px;right:0;left:0;margin-left:auto;margin-right:auto;width:fit-content;max-width:calc(100% - 50px);z-index:99;animation:", ";animation-duration:0.3s;animation-fill-mode:forwards;}"], SlideInAnimation);
const NewMessagesAlert = ({
  newMessageCount,
  onClickViewMessages,
  onClose
}) => {
  return /*#__PURE__*/_jsxs(StyledUIAlert, {
    use: "inline",
    closeable: true,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-right-3",
      message: 'conversations-thread-view.alerts.NEW_MESSAGES.alertLabel',
      options: {
        count: newMessageCount
      }
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'conversations-thread-view.alerts.NEW_MESSAGES.view_jsx',
      options: {
        onClick: onClickViewMessages
      },
      elements: {
        Link: UILink
      }
    })]
  });
};
NewMessagesAlert.displayName = 'NewMessageAlert';
NewMessagesAlert.propTypes = {
  newMessageCount: PropTypes.number.isRequired,
  onClickViewMessages: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
export default NewMessagesAlert;